import React, { useState, useEffect } from "react";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";
import * as viVN from "../../../language/vi-VN.json";

import Autocomplete from "@material-ui/lab/Autocomplete";
import RefreshIcon from "@material-ui/icons/Refresh";
import history from "../../../common/history";
import { useLocation } from 'react-router-dom';

import {
    TextField,
    Fab,
    Tooltip,
} from "@material-ui/core";

const listStatus = [
    { id: 1, name: 'Chờ xử lý', color: '#FF9800' },
    { id: 2, name: 'Đã xác nhận', color: '#2196F3' },
    { id: 3, name: 'Đang giao', color: '#9C27B0' },
    { id: 4, name: 'Hoàn thành', color: '#4CAF50' },
]

function BookOrderFilter(props) {
    const { hasFromToDate } = props;
    const location = useLocation();
    const url = location.pathname;
    const queryParams = new URLSearchParams(location.search);
    const [keyword, setKeyword] = useState('')
    const [sceneModels, setSceneModels] = useState([]);
    const [statusId, setStatusId] = useState(queryParams.get('status'));
    const [vrProjectModels, setVrProjectModels] = useState([]);
    const [curVrProject, setCurVrProject] = useState({ id: 0, name: 'Chọn Vr project' });

    const handleChangeName = (event) => {
        if (event.key === "Enter") {
            const value = event.target.value.trim();
            queryParams.set('keyword', value);
            pushParams();
        }
    }

    const handleRefresh = () => {
        setStatusId(0);
        setKeyword('');
        history.push({
            pathname: ''
        })
    }

    const pushParams = () => {
        history.push({
            search: queryParams.toString(),
        })
    }
    const handleUpdateStatus = (value) => {
        queryParams.set('status', value.id);
        setStatusId(value.id);
        pushParams();
    }

    return (
        <div>
            <div className="form_search_rs">
                <div className="row">
                    <div className="col-md-2">
                        <TextField
                            fullWidth
                            id="standard-basic"
                            // label="Từ khóa"
                            value={keyword}
                            onChange={(e) => setKeyword(e.target.value)}
                            placeholder="Nhập tên"
                            defaultValue={queryParams.get('keyword')}
                            // type="search"
                            variant="outlined"
                            InputProps={{ maxLength: 200 }}
                            onKeyPress={handleChangeName}
                        />
                    </div>
                    <div className="col-md-2">
                        <Autocomplete
                            id='combo-box-demo'
                            options={listStatus}
                            getOptionLabel={(option) => option.name}
                            placeholder="Chọn trạng thái"
                            onChange={(event, value) => handleUpdateStatus(value)}
                            style={{ width: '100%', minWidth: '150px' }}
                            value={listStatus.find((item) => item.id == statusId) || { id: 0, name: 'Chọn trạng thái' }}
                            disableClearable={true}
                            renderInput={(params) => {
                                return (
                                    <TextField
                                        {...params}
                                        variant='outlined'
                                        name="realEstateTypeId"
                                        size="small"
                                    />
                                );
                            }}
                        />
                    </div>
                    <div className={`col-md-2 form-item`}>
                        <div className="">
                            <Tooltip title="Làm mới">
                                <Fab
                                    color="primary"
                                    aria-label="filter"
                                    size="small"
                                    onClick={handleRefresh}
                                    className={`mr-3 ${!hasFromToDate ? 'mb-3' : ''}`}
                                >
                                    <RefreshIcon />
                                </Fab>
                            </Tooltip>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}


export default BookOrderFilter;